import { Input, Select } from '@alifd/next';
import React, { useState } from 'react';

import MainButton from '@/components/UI/mobile/MainButton';
import commonhelper from '@/lib/commonhelper';

import ShowCameraDetail from './components/ShowCameraDetail';
import styles from './index.module.scss';
const Option = Select.Option;

const CameraFontDesk = () => {
  const [openEditTodoModal, setOpenEditTodoModal] = useState(false);
  const [showOneCamera, setShowOneCamera] = useState({});
  // const [test, setTest] = useState(undefined);

  // const testOption = ['QRCode', 'Barcode', 'Text'];

  const closeEditTodoModal = () => {
    setOpenEditTodoModal(false);
    setShowOneCamera({});
    document.getElementById('cameraFrame').src = '';
  };

  const fakeData = [
    {
      name: '大門',
      url: 'http://eztw.in:9203/ezcon/cam/12?time=20240830-163820&camhash=886826&token=eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE3MTk1NDQ3MzMsImV4cCI6MTgxNDIxNzUzMywic3ViIjoiMSIsImp0aSI6ImU5YTAwYzAzLTA2NjAtNDU5NC04YWFhLTM4MGNhZjAxN2ExYSJ9.sAYOO5wo27P-QND0H9DtciRYEQeZqhzcwb4Dn1RK_wU',
    },
    {
      name: '會議',
      url: 'http://eztw.in:9203/ezcon/cam/8?time=20240830-162818&camhash=836dee&token=eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE3MTk1NDQ3MzMsImV4cCI6MTgxNDIxNzUzMywic3ViIjoiMSIsImp0aSI6ImU5YTAwYzAzLTA2NjAtNDU5NC04YWFhLTM4MGNhZjAxN2ExYSJ9.sAYOO5wo27P-QND0H9DtciRYEQeZqhzcwb4Dn1RK_wU',
    },
  ];
  return openEditTodoModal ? (
    <ShowCameraDetail
      closeModal={closeEditTodoModal}
      showOneCamera={showOneCamera}
    />
  ) : (
    <>
      <div className={styles.container}>
        {fakeData.map((value) => (
          <>
            <MainButton
              // style={}
              style={{ marginBottom: '2vw' }}
              onClick={() => {
                setOpenEditTodoModal(true);
                setShowOneCamera(value);
              }}
            >
              {value.name}
            </MainButton>
          </>
        ))}
      </div>
      {/* 20240905 QRCode測試成功 */}
      {/* <div>
        <Select
          onChange={async (value) => {
            const andTest = await commonhelper.androidScanner(value);
            const iosTest = await commonhelper.iosScanner(value);
            console.log(andTest, '===andTest');
            console.log(iosTest, '====iosTest');
            setTest(andTest ? andTest : iosTest);
          }}
        >
          {testOption.map((item) => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>
        <Input value={test} />
      </div> */}
    </>
  );
};

export default CameraFontDesk;
